import React from "react"

import { RoomTypeInput } from "shared/ui/room-type-input/RoomTypeInput"

interface InstallationReferenceRoomTypeFilterInputProps {
  loading?: boolean
}

export const InstallationReferenceRoomTypeFilterInput = React.memo(
  ({ loading }: InstallationReferenceRoomTypeFilterInputProps) => {
    return <RoomTypeInput name="roomTypes" loading={loading} elevated />
  }
)
